import React from 'react';
import Sidebar from '../sidebar/sidebar';
import { useSidebar } from '../../contexts/SidebarContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import styles from './layout.module.css';

export default function Layout({ children, selectedIndex }) {
  const { toggle } = useSidebar();

  return (
    <>
      <Sidebar selectedIndex={selectedIndex} />
      <button className={styles.menuButton} onClick={toggle} aria-label="Menu">
        <FontAwesomeIcon icon={faBars} />
      </button>
      <div className={styles.wrapper}>
        <div className={styles.mainArea}>
          <div className={styles.mainContent}>
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
